import React from 'react';

export const InningHalfIcon = () => {
    return (
        <svg
            data-testid="inning-half-svg"
            width="9px"
            height="6px"
            viewBox="0 0 9 6"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <title>Inning Arrow</title>
            <defs>
                <path d="M0,0 L6,4.5 L0,9 L0,0 Z" id="inningHalfPath"></path>
            </defs>
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="inningHalfBatsBothPlayers" transform="translate(-110.000000, -46.000000)">
                    <g id="inningHalfGroup-2" transform="translate(0.000000, 24.000000)">
                        <g id="inningHalfGroup" transform="translate(110.000000, 16.000000)">
                            <g transform="translate(0.000000, 5.000000)" id="Menu-Top">
                                <g transform="translate(0.000000, 1.000000)">
                                    <g
                                        id="inningHalfMenuRight"
                                        transform="translate(4.500000, 3.000000) rotate(-90.000000) translate(-4.500000, -3.000000) translate(1.500000, -1.500000)"
                                    >
                                        <mask id="inningHalfMask-2" fill="white">
                                            <use xlinkHref="#inningHalfPath"></use>
                                        </mask>
                                        <use id="scoreboard-winner" fill="#000000" xlinkHref="#inningHalfPath"></use>
                                        <g id="inningHalfGroup" mask="url(#inningHalfMask-2)" fill="#FFFFFF">
                                            <g id="inningHalfIconColor">
                                                <rect
                                                    id="inningHalfRectangle-7"
                                                    x="0"
                                                    y="0"
                                                    width="6"
                                                    height="9"
                                                ></rect>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
